export default "__VITE_ASSET__BFtdYXaq__"